import Image            from "gatsby-image";
import React            from "react";
import OgImage          from "../../../../assets/images/blog/article_17/og.png";
import {useAuthorsData} from "../../Authors/useAuthorsData";
import {ArticlePhotos}  from "./ArticlePhotos";

export const ArticleData = () => {
  const images = ArticlePhotos();
  const authors = useAuthorsData();

  return {
    date:              "22.03.2022r",
    category:          "content marketing, strategia",
    title:             <>Influencer Marketing - czym jest i&nbsp;dlaczego warto w niego inwestować?</>,
    SEO_title:         "Influencer Marketing - czym jest i dlaczego warto w niego inwestować?",
    description:
                       <>
                         Jeszcze dekadę temu influencer marketing ograniczał się do działań celebrytów i&nbsp;blogerów. Rozwój mediów społecznościowych diametralnie zmienił jego oblicze. Obecnie influencer marketing to jeden z&nbsp;najszybciej rozwijających się obszarów marketingu.
                       </>,
    seo:               "Jeszcze dekadę temu influencer marketing ograniczał się do działań celebrytów i blogerów. Rozwój mediów społecznościowych diametralnie zmienił jego oblicze. Obecnie influencer marketing to jeden z najszybciej rozwijających się obszarów marketingu.",
    slug:              "/blog/influencer-marketing-czym-jest-i-dlaczego-warto-w-niego-inwestowac",
    image:             OgImage,
    authors:           [
      authors.SylwiaBuksa,
    ],
    hero:              (
                         <Image
                           alt=""
                           objectPosition={"center"}
                           objectFit={"contain"}
                           fluid={images.hero.childImageSharp.fluid}
                         />
                       ),
    text:              {
      first:  {
        title: "Czym zajmuje się influencer marketing?",
        text:  <>
                 To forma marketingu, w której główną rolę odgrywa influencer, czyli osoba, posiadająca moc wpływania na decyzje zakupowe oraz opinie konsumentów na temat marki, produktu czy usługi. Dokonuje tego dzięki posiadanemu autorytetowi i&nbsp;własnej wiedzy. Bardzo ważne, jeśli nie najważniejsze, są jednak jego relacje z odbiorcami. <br/> <br/>
                 Sympatia, jaką darzą influencerów obserwujący, przyczynia się do utrzymywania ciągłej komunikacji i&nbsp;budowania zaufania. Publiczność większości influencerów jest im na tyle oddana, że z&nbsp;łatwością ulega ich wpływom. Influencer marketing w Polsce staje się coraz popularniejszy. Firmy chętnie nawiązują współprace z&nbsp;twórcami internetowymi, bo ich działania owocują skuteczną sprzedażą i&nbsp;mają realny wpływ na wizerunek marki.
               </>,
      },
      second: {
        title: "Co robi influencer?",
        text:  <>Ze względu na czas trwania współpraca internetowej osobowości z marką może przybierać formę ambasadorstwa lub pojedynczej akcji. W&nbsp;ramach umowy influencerzy mogą np. przygotować i&nbsp;opublikować w&nbsp;swoich kanałach cykl treści poświęcony produktowi, często zakończony konkursem lub rozdaniem. Niekiedy marki decydują się na zatrudnienie influencera do udziału w reklamie. Coraz częściej stawiają też na długofalowy sponsoring lub stworzenie nowego, wspólnego produktu.</>,
      },
      third:  {
        title: "Ile to kosztuje?",
        text:  <>
                 Współpraca często rozliczana jest na zasadzie wymiany barterowej (świadczona usługa za produkt) lub tradycyjnej zapłaty gotówką. O&nbsp;wysokości potrzebnego budżetu decyduje kilka czynników. Należy wziąć pod uwagę popularność i&nbsp;zasięg influencera, długość planowanej współpracy, a także oczekiwania dotyczące contentu (jakość i&nbsp;ilość zaplanowanych postów wpływa na cenę). <br/> <br/>
                 Jeśli zastanawiasz się, gdzie szukać influencerów i&nbsp;czy w ogóle stać Cię na taką współpracę, mamy dobrą wiadomość. Nawiązanie kontaktu z influencerem, działającym na mniejszą skalę, często przynosi więcej korzyści niż inwestowanie w&nbsp;„gwiazdy mediów społecznościowych”. Doświadczenia pokazują, że to właśnie pomniejsi twórcy gromadzą wokół siebie najbardziej zaangażowaną społeczność.
               </>
      },
      fourth: {
        title: "Co robić, żeby to działało?",
        text:  "Nastaw się na to, że powodzenie nie zależy od wysokości budżetu."
      },
      fifth:  {
        title: "Dlaczego warto inwestować w influencer marketing?",
        text:  <>Działania influencerów mogą przede wszystkim pozytywnie wpłynąć na wizerunek marki i&nbsp;zwiększenie sprzedaży produktów oraz usług. Pozwalają też na precyzyjne dotarcie do nowych grup docelowych (w&nbsp;tym odmiennych niż już posiadane). Mnogość twórców i&nbsp;tematów jest tak duża, że łatwo znaleźć kogoś, kto zajmuje się naszą dziedziną, nawet jeśli ta jest bardzo niszowa. <br/> <br/>
          Zaletę stanowi też sposób prezentowania produktów. Influencerzy robią to kreatywnie, a&nbsp;przy tym nienachalnie. W&nbsp;oczach odbiorców polecają coś, ale niczego nie narzucają, zachowują obiektywizm. Trzeba przyznać - tym wygrywają z większością reklam. Ponadto influencer marketing uwiarygadnia markę w oczach klientów - pokazuje, że osoby znane i&nbsp;lubiane korzystają z naszych usług, a nawet więcej - są zadowolone! <br/> <br/>
          Jeśli znalezienie odpowiedniego dla Twojej marki influencera i&nbsp;nawiązanie z nim współpracy wydaje się zbyt czasochłonne lub skomplikowane, <a href="/kontakt#formularz_kontaktowy">napisz do nas!</a> Chętnie pomożemy.
               </>,
      },
    },
    list:              {
      first: {
        title:   "Pamiętaj o tym, żeby:",
        text:    "",
        content: [
          <><strong>Nie oceniać influencera na podstawie ilości obserwujących.</strong> <br/> Szerokie zasięgi nie zawsze idą w parze z interesującym contentem i&nbsp;aktywną społecznością. Zamiast liczby followersów sprawdź zaangażowanie pod postami. </>,
          <><strong>Szukać influencerów podzielających wartości Twojej firmy.</strong> <br/>Jeśli zależy Ci na autentycznym przekazie, zadbaj o to, by z&nbsp;marką utożsamiała się osoba o podobnych poglądach.</>,
          <><strong>Weryfikować ilość współprac influencera.</strong> <br/>Twórca, który dodaje zbyt dużo postów sprzedażowych, może łatwo stracić sympatię obserwujących. Poza tym na takim kanale Twoja marka łatwo zginie w tłumie.</>,
          <><strong>Dobierać influencerów z&nbsp;myślą o&nbsp;swojej grupie docelowej.</strong> <br/>Choć jednym z&nbsp;celów współpracy jest poszerzenie grona odbiorców o całkiem nowe osoby, musisz zadbać o dotarcie do tych, którym dedykowany jest Twój produkt.</>,
          <><strong>Dać influencerom wolność.</strong> <br/>Określ jasno swoje oczekiwania i&nbsp;warunki współpracy na samym początku, ale bądź otwarty na pomysły twórcy. To często owocuje kreatywnymi, nieszablonowymi rozwiązaniami. Polecamy chaos kontrolowany. :)</>
        ]
      }
    },
    imagesWithCaption: {
      first:  {
        img:     (
                   <Image
                     alt=""
                     objectPosition={"center"}
                     objectFit={"contain"}
                     fluid={images.img_1.childImageSharp.fluid}
                   />
                 ),
        caption: "",
        width:   1000,
      },
      second: {
        img:     (
                   <Image
                     alt=""
                     objectPosition={"center"}
                     objectFit={"contain"}
                     fluid={images.img_2.childImageSharp.fluid}
                   />
                 ),
        caption: "",
        width:   1000,
      },
    },
  };
};
